import { Navigate } from 'react-router-dom';
import React from 'react';

import { useStores } from '@/hooks/use-stores';
import { AuthenticationType } from '@/store/SiteSurveyForm/constants';

export function NavigateToLogin({ from }: { from: { pathname: string; search: string } }) {
  const { userStore } = useStores();
  let loginUrl = '/login';
  const redirectPath = from?.pathname || '/home';
  const searchParams = from?.search || '';
  localStorage.setItem('redirectAfterLogin', redirectPath + searchParams);
  if (userStore.authenticationType === AuthenticationType.SSO) {
    loginUrl = '/login/sso';
  }
  return <Navigate replace to={loginUrl} state={{ from }} />;
}
